import { create } from 'zustand';
import type { ProjectDocument } from 'common/project/ProjectDocument';
import { EditAppState } from 'client/lib/EditApp';

export interface ProjectState extends EditAppState<ProjectDocument> {}

const initialState: ProjectState = {
  document: null,
};

export const useProjectState = create(() => initialState);
